export default __webpack_public_path__ + "static/media/remix.117d9ef0.png";